{
  "attachAria": "ファイルを添付",
  "emptyHint": "内容を入力してください。サポートがここで返信します",
  "emptyTitle": "まだメッセージはありません",
  "fileOpenAria": "添付ファイルを開く",
  "logAria": "お問い合わせのやり取り",
  "newMessages": "新着メッセージ",
  "placeholder": "メッセージを入力…",
  "placeholderDisabled": "メッセージは一時的に利用できません",
  "previewAria": "添付ファイルを表示",
  "previewCloseAria": "プレビューを閉じる",
  "removeAttachmentAria": "ファイルを削除",
  "retry": "再試行",
  "screenshotAria": "スクリーンショットを撮る",
  "seen": "既読",
  "sendAria": "メッセージを送信",
  "sendFailed": "メッセージを送信できませんでした",
  "sending": "送信中…",
  "student": "受講生",
  "supportName": "Skyengサポート",
  "today": "今日",
  "yesterday": "昨日",
  "you": "あなた"
}
